export const JOURNEY_RESET_STATE = 'JOURNEY_RESET_STATE';
export const JOURNEY_CURRENT_ITEM = 'JOURNEY_CURRENT_ITEM';

export const JOURNEY_REQUEST_LOADING = 'JOURNEY_REQUEST_LOADING';
export const JOURNEY_REQUEST_SUCCESS = 'JOURNEY_REQUEST_SUCCESS';
export const JOURNEY_REQUEST_FAILED = 'JOURNEY_REQUEST_FAILED';

export const JOURNEY_CURRENT_ACTION = 'JOURNEY_CURRENT_ACTION';
export const JOURNEY_RESET_ACTION = 'JOURNEY_RESET_ACTION';